var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizer9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 332,
    viewBox: "0 0 332 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 332,
    rx: 20,
    transform: "translate(692 555) rotate(180)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 20,
    transform: "translate(692 343) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(558 323) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(692 459) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    transform: "translate(692 555) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    transform: "translate(440 303) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizer9);
export default __webpack_public_path__ + "static/media/visualizer-9.abd96fe59655056255a8333397cb0695.svg";
export { ForwardRef as ReactComponent };